import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'
import './pwaInstall' // PWA: beforeinstallprompt vroeg opvangen
import { AuthProvider } from './contexts/AuthContext.jsx'
import { registerSW } from 'virtual:pwa-register'

// PWA: service worker registreren (autoUpdate; nieuwe versie laadt bij volgende bezoek)
if ('serviceWorker' in navigator) {
  registerSW({ immediate: true })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)